import React from 'react';
import styles from '../asset/scoreStatisticBoard.module.scss';

const ProgressBar = ({ current, max }) => {
    const isValidNumber = typeof current === 'number';
    const percentage = isValidNumber ? (current / max) * 100 : 0;
    
    // Show minimum 1% width when value is 0 or null to indicate starting point
    const displayPercentage = (isValidNumber && percentage === 0) || !isValidNumber ? 1 : percentage;

    return (
        <div className={styles.progressBarWrapper}>
            <span className={styles.progressLabel}>0%</span>
            <div className={styles.progressBar}>
                <div className={styles.progressTrack} />
                <div className={styles.progressFill} style={{ width: `${displayPercentage}%` }} />
            </div>
            <span className={styles.progressLabel}>100%</span>
        </div>
    );
};

export default ProgressBar;
